import React from "react";
import moment from "moment";

export default function StatusAgendamento({ status, data }) {
  let statusAgendamento = status;
  let texto = "";
  let cor = "#000000";

  // Verifica se a data do agendamento já passou e se o status é pendente
  if (moment(data).isBefore(moment(), "day") && statusAgendamento === 1) {
    statusAgendamento = 4; // Define como Finalizado
  }

  if (statusAgendamento === 1) {
    texto = "Pendente";
    cor = "#16ADAD";
  } else if (statusAgendamento === 2) {
    texto = "Em andamento";
    cor = "#f5c92c";
  } else if (statusAgendamento === 3) {
    texto = "Não confirmado";
    cor = "#f5c92c";
  } else if (statusAgendamento === 4) {
    texto = "Finalizado";
    cor = "#1BA062";
  } else if (statusAgendamento === 5) {
    texto = "Cancelado";
    cor = "#eb445a";
  } else if (statusAgendamento === 6) {
    texto = "Reembolsado";
    cor = "#eb445a";
  } else {
    texto = "Não encontrado";
    cor = "#000000";
  }

  return (
    <span>
      <h5
        style={{
          marginTop: "7px",
          marginBottom: "5px",
        }}
      >
        <i className="ri-checkbox-blank-circle-fill" style={{ color: cor }}></i>{" "}
        &nbsp; Status: {texto}
      </h5>
    </span>
  );
}
